import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const translationResources = {
  en: {
    translation: {
      home: "Home",
      competition: "Competition",
      membersNav: "Members",
      contact: "Contact",
      homeHeading1: "Lambada World",
      homeHeading2: "Dance Council",
      homeDescription:
        "Our mission is to promote the growth and development of the global Lambada community by establishing a unified framework for competitions and offering support for competitors, organizers, DJs, and judges to ensure fairness and consistency across events, and to celebrate the art of Lambada through unity, culture, and respect.",
      competitionGuideHeading: "Download the official competitor's guide here",
      judges: "Judges",
      djs: "DJs",
      members: "Council Members",
      getInTouch: "Get in Touch",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      yourMessage: "Your Message",
      submit: "Submit",
      guideButton: "Guide",
      infoButton: "Information",
    },
  },
  pt: {
    translation: {
      home: "Início",
      competition: "Competição",
      membersNav: "Membros",
      contact: "Contato",
      homeHeading1: "Conselho Mundial de",
      homeHeading2: "Dança Lambada",
      homeDescription:
        "Nossa missão é promover o crescimento e o desenvolvimento da comunidade global de Lambada, estabelecendo uma estrutura unificada para competições e oferecendo suporte a competidores, organizadores, DJs e juízes para garantir justiça e consistência em eventos, celebrando a arte da Lambada através da unidade, cultura e respeito.",
        competitionGuideHeading: "Baixe aqui o guia oficial do compeditador",
        judges: "Juízes",
        djs: "DJs",
        members: "Membros do Conselho",
        getInTouch: "Entre em Contato",
        firstName: "Nome",
        lastName: "Sobrenome",
        email: "E-mail",
        yourMessage: "Sua Mensagem",
        submit: "Enviar",
        guideButton: "Guia",
        infoButton: "Informativos",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: translationResources,
    fallbackLng: localStorage.getItem('language') || 'en', // Default to stored language or 'en'
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
